var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0976562,
    width: 16,
    height: 15.5296,
    rx: 7.76479,
    fill: "#FFB703"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00053 13.9073C11.2088 13.9073 13.8097 11.3065 13.8097 8.09819C13.8097 4.8899 11.2088 2.28906 8.00053 2.28906C4.79224 2.28906 2.19141 4.8899 2.19141 8.09819C2.19141 11.3065 4.79224 13.9073 8.00053 13.9073Z",
    fill: "white",
    stroke: "#F99300",
    strokeWidth: 1.58375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6953 14.8165C12.0233 14.279 13.1605 13.3572 13.9612 12.1691C14.7618 10.9811 15.1895 9.58108 15.1893 8.14844",
    stroke: "#FFCC29",
    strokeWidth: 0.950152,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40234 1.86923C5.495 1.23663 6.73559 0.904395 7.99816 0.906258",
    stroke: "#FFCC29",
    strokeWidth: 0.950152,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95703 4.20424C2.30726 3.6617 2.72876 3.16864 3.21022 2.73828",
    stroke: "#FFCC29",
    strokeWidth: 0.950152,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68368 11.5425C1.10786 10.4871 0.806922 9.30379 0.808601 8.10156",
    stroke: "#FFCC29",
    strokeWidth: 0.950152,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0977C11.3137 14.0977 14 11.4114 14 8.09766C14 4.78395 11.3137 2.09766 8 2.09766C4.68629 2.09766 2 4.78395 2 8.09766C2 11.4114 4.68629 14.0977 8 14.0977Z",
    fill: "#FFCC29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37445 7.00809L7.98904 5.1192C7.97982 5.10654 7.96746 5.09618 7.95304 5.08902C7.93861 5.08186 7.92256 5.07812 7.90626 5.07812C7.88995 5.07812 7.8739 5.08186 7.85947 5.08902C7.84505 5.09618 7.83269 5.10654 7.82347 5.1192L6.43806 7.00809C6.42479 7.02631 6.40518 7.0396 6.38262 7.04566C6.36007 7.05171 6.33597 7.05016 6.3145 7.04127L4.34867 6.2186C4.33112 6.21134 4.31173 6.20893 4.29278 6.21166C4.27383 6.21439 4.25609 6.22214 4.24165 6.23401C4.2272 6.24588 4.21664 6.26138 4.21119 6.2787C4.20575 6.29602 4.20564 6.31444 4.2109 6.3318L5.35074 10.0089C5.35682 10.0286 5.36954 10.046 5.38697 10.0583C5.40441 10.0706 5.42562 10.0773 5.44742 10.0773H10.3654C10.3872 10.0773 10.4084 10.0706 10.4258 10.0583C10.4433 10.046 10.456 10.0286 10.4621 10.0089L11.6019 6.3318C11.6072 6.31444 11.6071 6.29602 11.6016 6.2787C11.5962 6.26138 11.5856 6.24588 11.5712 6.23401C11.5567 6.22214 11.539 6.21439 11.52 6.21166C11.5011 6.20893 11.4817 6.21134 11.4642 6.2186L9.49832 7.04127C9.47678 7.05007 9.45268 7.05157 9.4301 7.04552C9.40752 7.03947 9.38786 7.02625 9.37445 7.00809Z",
    fill: "#F99300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.db6a7242e8efad43b035c556e6d13571.svg";
export { ForwardRef as ReactComponent };